/* eslint-disable complexity */
/* global site*/
(function ($) {
  var isMobileLayout =
    $('html').hasClass('device-mobile') || (Modernizr.touch && $(window).width() < 1024);
  var mobileWindowHeight = $(window).height() * 0.7;
  var ELCMacLooksGrid = function ($gridElement) {
    var self = this;

    self.$gridWrapper = $gridElement;
    self.$gridsContainer = $gridElement.closest('.js-looks-destination-grids-container');
    self.label = $gridElement.data('label');
    self.permalink = $gridElement.data('permalink');
    self.transitionInProgress = false;
    self.transitionInProgressTimeout;
    self.$lastActiveArticle;
    self.$renderedArticle = self.$gridWrapper
      .closest('.js-looks-destination-page-formatter--v1')
      .find('.js-looks-destination-rendered-article');
    self.$carousel = self.$gridWrapper.find('.js-looks-destination-grid-carousel');
    self.$grid = $gridElement.find('.js-looks-destination-grid');
    self.$articles = $('.js-looks-destination-article', $gridElement);
    self.pagination = {
      oldIndex: 0,
      currentPage: 0,
      $currentPage: self.$gridWrapper.find('.js-looks-destination-grid-pagination-current'),
      $totalPages: self.$gridWrapper.find('.js-looks-destination-grid-pagination-total')
    };
    self.setupArticleTemplates();
    $(document).on('ELCMacLooksPage.touchGridScrollTranslateY', function () {
      if (self.transitionInProgressTimeout) {
        clearTimeout(self.transitionInProgressTimeout);
      }
      self.transitionInProgress = true;
      self.transitionInProgressTimeout = setTimeout(function () {
        self.transitionInProgress = false;
      }, 800);
    });
    $(window).on(
      'resize',
      _.debounce(function () {
        self.setupArticleTemplates();
      }, 100)
    );
  };

  ELCMacLooksGrid.prototype.analyticsEvtLink = function (analyticsObject) {
    if (site && site.track && site.track.evtLink) {
      site.track.evtLink(analyticsObject);
    }
  };

  ELCMacLooksGrid.prototype.setupArticleTemplates = function () {
    var self = this;
    var targetWidth = $(window).width();
    var targetHeight = $(window).height() * 0.7 + 70;
    var targetRatio = targetHeight / targetWidth;
    // Unwrap our article Media asset
    // experimentally show a video
    var assetQueue = [];

    self.$articles.each(function () {
      var $article = $(this);
      var $media = $(this).find('script.js-article-media');
      var horizontalRatio =
        self.$grid.width() /
        ($article.hasClass('js-looks-destination-article-featured')
          ? $article.find('.js-looks-destination-article-zoom').width() - 2
          : $article.width() - 2);
      var verticalFactor =
        (isMobileLayout ? mobileWindowHeight : self.$grid.height()) / $article.height();
      var articleScaleFactorX = Math.max(horizontalRatio, verticalFactor);

      if ($media.length) {
        var $mediaContent = $($media.html());
        var $img = $mediaContent.find('img');

        if ($img.length) {
          assetQueue.push({
            $img: $img,
            $mediaParent: $media.parent(),
            link: $article.data('permalink')
          });
        } else {
          $media.replaceWith($media.html());
        }
        $media.remove();
      }
      if (isMobileLayout) {
        var resizedTargetHeight =
          ($article.height() / $article.width()) * targetRatio * $article.width();

        $article.attr('data-target-height', resizedTargetHeight);
      }
      $article.attr('data-scale', articleScaleFactorX);
      $article.attr('data-position-left', $article.position().left);
    });

    function loadAssets() {
      if (!assetQueue.length) {
        $(document).trigger('ELCMacLooksOverlayAssets.ready');

        return false;
      }
      var assetObject = assetQueue.shift();
      var srcValue = assetObject.$img.data('src')
        ? assetObject.$img.data('src')
        : assetObject.$img.attr('src');
      var $cloned = assetObject.$mediaParent.clone();
      var fullImageSlide =
        '<div class="looks-article-full-frame"><img class="js-looks-destination-thumbnail js-looks-destination-lazyload looks-destination-lazyload" data-src="' +
        srcValue +
        '?imwidth=' +
        (isMobileLayout ? $(window).width() : parseInt($(window).width() / 2)) +
        '" /></div>';

      $cloned
        .html(fullImageSlide)
        .appendTo(self.$gridWrapper.find('.js-looks-destination-grid-carousel'));

      var $thumbnail = $(
        '<img class="js-looks-destination-grid-pagination--thumbnail js-looks-destination-lazyload looks-destination-lazyload" data-src="' +
          srcValue +
          '?imWidth=100"/>'
      );
      $thumbnail.appendTo(self.$gridWrapper.find('.js-looks-destination-grid-pagination--preview'));

      var smallImageSlide =
        '<div class="looks-article-small-frame"><a href="' +
        assetObject.link +
        '"><img class="js-looks-destination-lazyload looks-destination-lazyload" data-src="' +
        srcValue +
        '?imwidth=' +
        assetObject.$mediaParent.width() +
        '" /></a></div>';

      assetObject.$mediaParent.append(smallImageSlide);
      assetObject.$mediaParent.append(fullImageSlide);
      loadAssets();
    }
    loadAssets();
    // Setup Event listeners
    self.$articles
      .off('click.articleOpen open.withoutAnimation')
      .on('click.articleOpen open.withoutAnimation', function (event) {
        var $article = $(this);

        event.preventDefault();
        if ($article.hasClass('active') || self.transitionInProgress) {
          return false;
        }
        self.setupArticleTemplates();
        $article.trigger('looks.zoom-in');
        if (event.type === 'click') {
          $(document).trigger('ELCMacLooksPage.pause');
          self.analyticsEvtLink({
            event_name: 'maclooks',
            event_category: 'looks destination',
            event_action: 'looks squares - click',
            event_label: $article.data('permalink').replace('+', ' ').trim()
          });
        }
      });

    self.$articles.off('looks.zoom-in').on('looks.zoom-in', function () {
      if (self.transitionInProgress || !self.$gridWrapper.hasClass('active')) {
        return false;
      }

      var $article = $(this);
      var scaleFactor = parseFloat($article.attr('data-scale')).toFixed(2);
      var calculatedTime = (scaleFactor * $article.width() - $article.width()) / 60;
      var dynamicTransitionTime = isMobileLayout ? '.7s' : calculatedTime * 0.1 + 's';

      if (
        isMobileLayout &&
        !self.$grid.parent().find('.js-looks-destination-article.active').length
      ) {
        self.$grid
          .closest('.looks-destination-formatter')
          .find('.looks-destination__panel, .looks-destination__content')
          .css({
            transition: 'all ' + dynamicTransitionTime + ' cubic-bezier(0.895, 0.030, 0.685, 0.220)'
          });
      }
      self.transitionInProgress = true;
      requestAnimationFrame(function () {
        self.$gridWrapper.addClass('transitioning');
        self.$grid.css({
          'transform-origin': self.getLockpoint($article),
          transition: 'transform ' + dynamicTransitionTime,
          transform: 'scale(' + scaleFactor + ')'
        });
      });
      $(document).trigger('ELCMacLooksGrid.initArticleOverlay', [$article]); // Rearrange the width of the overall page and load article overlay
      requestAnimationFrame(function () {
        $article.addClass('active');
        setTimeout(function () {
          $article.removeClass('exiting-animation').addClass('activation-animation');
          if (!isMobileLayout) {
            var heightAmount = $(window).height() - 140;
            var windowScaleFactor = heightAmount / ($(window).width() / 2);

            requestAnimationFrame(function () {
              $article.css({
                'min-height': '0px',
                'max-height': Math.ceil(windowScaleFactor * $article.width()) + 'px'
              });
            });
          }
        }, 1);
      });
    });
    $(document).on(
      'ELCMacLooksGridOverlay.rotateArticle',
      _.debounce(function (event, $article) {
        var scaleFactor = parseFloat($article.attr('data-scale'));

        self.$articles.removeClass('activation-animation exiting-animation');
        $article.addClass('active activation-animation');
        $article.closest('.js-looks-destination-grid').css({
          transition: 'transform 0s',
          'transform-origin': self.getLockpoint(
            $article,
            self.$gridsContainer.data('active-translatey') === self.$gridWrapper.data('translatey2')
          ),
          transform: 'scale(' + scaleFactor + ')'
        });
      }, 800)
    );
    $(document).on('ELCMacLooksGridOverlay.closed', function () {
      self.$articles.removeClass('activation-animation').addClass('exiting-animation').css({
        'min-height': '',
        'max-height': ''
      });
      self.transitionInProgress = true;
      setTimeout(
        function () {
          self.transitionInProgress = false;
        },
        isMobileLayout ? 1000 : 1
      );
      requestAnimationFrame(function () {
        self.$gridWrapper.removeClass('transitioning');
        requestAnimationFrame(function () {
          self.$grid.css({
            transition: 'transform 1s',
            transform: 'scale(1)'
          });
        });
      });
    });
  };
  ELCMacLooksGrid.prototype.getLockpoint = function ($article, assumeScrolled) {
    var self = this;
    var index = $article.index();

    if (isMobileLayout) {
      switch (index) {
        case 0:
          return 'right 40.5%';
        case 1:
          return '2px 2px';
        case 2:
          return 'top center';
        case 3:
          return 'top right';
        case 4:
          if (!assumeScrolled && !self.$grid.position().top) {
            return 'left 85%';
          }

          return 'left 64%';
        case 5:
          if (!assumeScrolled && !self.$grid.position().top) {
            return '75% 85%';
          }

          return '75% 64%';
        case 6:
          if (!assumeScrolled && !self.$grid.position().top) {
            return 'center 202%';
          }

          return 'center 125%';
        case 7:
          if (!assumeScrolled && !self.$grid.position().top) {
            return 'left 64%';
          }

          return 'left 43%';
        case 8:
          if (!assumeScrolled && !self.$grid.position().top) {
            return 'center 64%';
          }

          return 'center 43%';
        case 9:
          if (!assumeScrolled && !self.$grid.position().top) {
            return 'right 64%';
          }

          return 'right 43%';
      }
    } else {
      switch (index) {
        case 0:
          return '1% center';
        case 1:
          return '1% 2px';
        case 2:
          return ($article.attr('data-position-left') / ($(window).width() / 2)) * 100 - 1 + '% 0%';
        case 3:
          return ($article.attr('data-position-left') / ($(window).width() / 2)) * 100 - 2 + '% 0%';
        case 4:
          return (
            ($article.attr('data-position-left') / ($(window).width() / 2)) * 100 - 2 + '%  30%'
          );
        case 5:
          return '99.9% 0%';
        case 6:
          return '99.9% 100%';
        case 7:
          return '1% 90%';
        case 8:
          return ($article.attr('data-position-left') / ($(window).width() / 2)) * 100 + '% 90%';
        case 9:
          return (
            ($article.attr('data-position-left') / ($(window).width() / 2)) * 100 - 1 + '% 90%'
          );
        default:
          break;
      }
    }
  };

  ELCMacLooksGrid.prototype.getLabel = function () {
    return this.label || '';
  };

  ELCMacLooksGrid.prototype.getPermalink = function () {
    return this.permalink || '';
  };

  Drupal.behaviors.looksDestinationGridV1 = {
    attach: function (context) {
      var $modules = $('.js-looks-destination-grid--v1', context);
      var macLooksGridObjectsCollection = [];

      $modules.each(function () {
        var $module = $(this);
        var macLooksGridObject = new ELCMacLooksGrid($module);

        macLooksGridObjectsCollection.push(macLooksGridObject);
      });
      $(document).trigger('ELCMacLooksGrids.ready', [macLooksGridObjectsCollection]);
    }
  };
})(jQuery);
